
export default {
  id: "id",
  name: "name",
  createdAt: "created_at",
};
